// extracted by mini-css-extract-plugin
module.exports = {"arrowsContainer":"CustomArrows_arrowsContainer__AP9Oq","arrowWrapper":"CustomArrows_arrowWrapper__y5mo6"};